"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M17 5.5H7A1.5 1.5 0 005.5 7v10A1.5 1.5 0 007 18.5h10a1.5 1.5 0 001.5-1.5V7A1.5 1.5 0 0017 5.5z", fill: "inherit", stroke: "currentColor" }),
    React.createElement("path", { d: "M9 12h6", stroke: "currentColor" })), "CheckboxIndeterminate");
//# sourceMappingURL=CheckboxIndeterminate.js.map